const PbxxRecord = require('../pbxx_record')

module.exports = class InstagramShare extends PbxxRecord {
  static get class_name() {
    return 'InstagramShare'
  }
}
